import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Block List Data (with stateID)
export const fetchBlockList = createAsyncThunk(
  "block/fetchBlockList",
  async (stateID, { rejectWithValue }) => {
    try {
      let response;
      // console.log(stateID);

      if (!stateID || stateID === "undefined") {
        response = await api.get(`/location/panel/BlockList`);
      } else {
        response = await api.get(`/location/panel/BlockList?stateID=${stateID}`);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Add Block to the List
export const addBlockList = createAsyncThunk(
  "block/addBlockList",
  async (newBlockData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/BlockList", newBlockData);
      alertSuccess(response.data.success);
      return newBlockData;
    } catch (error) {
      console.log(error.message);
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Block List Data
export const updateBlockList = createAsyncThunk(
  "block/updateBlockList",
  async (blockData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/BlockList", blockData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Block List Slice
const blockSlice = createSlice({
  name: "block",
  initialState: {
    blockList: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Block List
      .addCase(fetchBlockList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchBlockList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.blockList = action.payload;
      })
      .addCase(fetchBlockList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Add Block
      .addCase(addBlockList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addBlockList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addBlockList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Block List
      .addCase(updateBlockList.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateBlockList.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateBlockList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = blockSlice.actions;

export default blockSlice.reducer;
